var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5"},_vm._l((_vm.messages),function(message,key){return (_vm.messages.length > 0)?_c('div',{key:key,staticClass:"intro-y rounded-md flex items-center px-5 py-4 mb-2 bg-theme-18 text-theme-9"},[_c('fa-icon',{staticClass:"w-6 h-6 mr-2",attrs:{"icon":['fas', 'check']}}),_vm._v(" "+_vm._s(message)+" ")],1):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }